'use strict';

/* globals RELATIVE_PATH, $, utils */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	Vue.component('fill-blanks-game-word', {
		props: ['initData', 'word', 'onWordSuccess', 'goNext'],
		data: function () {
			return {
				letters: [],
				wrongAnswers: 0,
			};
		},
		watch: {
			word: function () {
				var me = this;
				
				this.letters = this.prepareLetters();
				this.wrongAnswers = 0;
				
				setTimeout(function () {
					me.goToNextLetter(-1);	
				}, 250); // needs to wait for render
			}
		},
		methods: {
			prepareLetters: function () {
				var letters = this.word.word.split('');

				var lettersObject = [];
				for (var i = 0; i < letters.length; i++) {
					lettersObject.push({
						letter: letters[i],
						value: letters[i],
						disabled: letters[i] === ' ',
						correctAnswer: true
					});
				}

				var lettersToHide = this.word.mode === 'defined' 
					? this.word.lettersToHide 
					: this.createRandomLettersToHide(this.word.lettersToHideCount, lettersObject.length, letters);
				
				this.disableLetters(lettersObject, lettersToHide);

				return lettersObject;				
			},
			disableLetters: function (lettersObject, lettersToHide) {
				for (var i = 0; i < lettersObject.length; i++) {
					if (!lettersToHide.includes(i)) {
						lettersObject[i].disabled = true;	
					} else if (!lettersObject[i].disabled) {
						lettersObject[i].correctAnswer = false;
						lettersObject[i].value = '';
					}
				}
			},
			createRandomLettersToHide: function (length, max, letters) {
				var lettersToHide = [];
				for (var i = 0; i < max; i++) {
					if (letters[i] !== ' ')
						lettersToHide.push(i);
				}
				
				lettersToHide.shuffle();
				
				return lettersToHide.slice(0, length);
			},
			input: function(e) {
				var addedLetter = e.data;
				$(e.target).val(addedLetter);
				
				var index = parseInt($(e.target).attr('data-index'), 10);
				
				var letter = this.letters[index];
				
				letter.value = addedLetter;
				
				letter.correctAnswer = addedLetter && addedLetter.toUpperCase() === letter.letter.toUpperCase(); 
				
				if (letter.correctAnswer) {
					this.playAudio('success');
					
					this.goToNextLetter(index);
					this.checkSuccess();
				} else {
					this.playAudio('fail');
					this.wrongAnswers = this.wrongAnswers + 1;
				}
			},
			goToNextLetter: function (prevIndex) {
				var nextToFill = $('.letters > .letter').splice(prevIndex + 1).find(function (n) {
					return $(n).attr('disabled') !== 'disabled';
				});
				
				if (nextToFill) {
					$(nextToFill).focus();
				}
			},
			checkSuccess: function () {
				var stillToAnswer = this.letters.find(function (n) {
					return n.correctAnswer === false;
				});
				
				if (!stillToAnswer) {
					this.onWordSuccess(this.wrongAnswers);
				}
			},
			playAudio: function (name) {
				var audio = new Audio(RELATIVE_PATH + '/plugins/nodebb-plugin-fill-blanks-game/static/sounds/' + name + '.mp3');
				
				audio.play();
			}
		},
		template: 
		'<div class="letters">' +
			'<input ' +
				'type="text" ' +
				':class="{\'letter\': true, \'valid\': letter.correctAnswer && !letter.disabled, \'invalid\': !letter.correctAnswer}" ' +
				':value="letter.value" ' +
				':disabled="letter.disabled" ' +
				':data-index="index"' +
				'v-on:keyup.enter="goNext"' +
				'@input="input" ' +	
				'v-for="(letter, index) in letters"  />' +
		'</div>',
	});
});
